/**
 * Constants for wordcloud configuration and behavior
 */

// Font size adjustment constants
export const FONT_SIZE_ADJUSTMENT = {
  FONT_DECREASE_FACTOR: 0.3,
  // Minimum margin between adjusted max font and min font
  MIN_MARGIN: 10,
  // Factor to estimate word area from font size (approximation)
  WORD_AREA_FACTOR: 3,
};

export const ADJUSTMENT_THRESHOLDS = {
  // Ratio of words with max value that triggers font size reduction
  HIGH_VALUE_RATIO: 0.5,
  // Minimum number of total words to trigger adjustment
  MIN_WORDS_COUNT: 10,
  // Maximum percentage of canvas area that estimated words should occupy
  MAX_CANVAS_COVERAGE: 0.5,
};

export const WORDCLOUD_TOOLTIP_VERSION_HEIGHT = 23;
